module.exports = __webpack_public_path__ + "static/media/Photo.svg";